import React, { useEffect, useCallback, useState} from 'react';
import {ZMESSAGE} from 'constants/object-types.js';
import {connect} from 'react-redux';
import VariableContext from './VariableContext.js';

const VariableName = ({variable, pattr}) => { 
    let isMacro = variable.getObjectType() !== ZMESSAGE;
          
    return (
        <div className="variable-name">
          {isMacro ? <div
                       style={{backgroundColor: variable.attributes["secondary-color"] || "gray"}}
                       className="v-color"></div> :
          <img src="/znumber-light.svg"/>}
          <VariableContext variable={variable} pattr={pattr}/>
        </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VariableName);
